import TYPES from '../types'

const initialState = {
  data: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  }
}

const RiderData = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ALT_RIDER_LISTS:
      return {
        ...state,
        ...action.data
      }
    case TYPES.LOGOUT:
      return initialState
    default:
      return state
  }
}

export default RiderData
